import { campaignData as cd } from '../../dummy/campaignData'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import AvailableRewards from './AvailableRewards'

const CampaignDetails = ({ campaignData = cd }) => {
  const params = useParams()
  const getCampaignDetails = (id?: string) => {
    return campaignData.find((campaign) => campaign.campaignId === id)
  }
  const navigate = useNavigate()
  const campaign = getCampaignDetails(params.campaignId)

  useEffect(() => {
    if (!campaign) {
      console.log('Campaign not found')
      navigate(-1)
    }
  }, [campaign])

  console.log(campaign)
  return campaign ? (
    <section className={'mx-auto w-full max-w-[calc(100%_-_2rem)]'}>
      <div className="flex flex-col gap-y-6">
        <div className="aspect-video max-h-44 w-full overflow-clip rounded-2xl bg-white p-0 lg:max-h-64">
          <img
            src={campaign.campaignImageUrl}
            className={'h-full w-full object-contain'}
            alt=""
          />
        </div>
        <div className="flex flex-col gap-y-2 px-4">
          <p className="text-base font-semibold">{campaign.title}</p>
        </div>
      </div>
      <div className="mt-4 flex flex-col gap-y-4 px-4">
        <p className=" ">{campaign.description}</p>
        {/* <p className='text-start text-base font-semibold'>
          Available at selected branches
        </p> */}
        {/* <Branches /> */}
        <AvailableRewards />
      </div>
    </section>
  ) : null
}
export default CampaignDetails
